import type { OrderSummary } from "@cyh/contracts";
import { CalendarDays, ChevronRight, CircleCheck, PackageCheck } from "lucide-react";
import { useLanguage } from "../i18n";

export function OrderCard({ order, onOpen }: { order: OrderSummary; onOpen?: (orderNo: string) => void }) {
  const { t } = useLanguage();
  const current = order.timeline.find((step) => step.state === "current");
  return <article className="order-card">
    <div className="order-card__top">
      <div>
        <span className="eyebrow">{order.orderNo}</span>
        <h3>{order.customerName}</h3>
        <p>{order.productName}</p>
      </div>
      <span className="status-dot"><span />{current?.label}</span>
    </div>
    <div className="order-meta">
      <span><CalendarDays size={15} />{t("交期", "Delivery")} {order.deliveryDate}</span>
      <span><PackageCheck size={15} />{t("负责人", "Owner")} {order.ownerName}</span>
    </div>
    <div className="progress-label"><span>{t("订单总进度", "Overall progress")}</span><strong>{order.progress}%</strong></div>
    <div className="progress-track"><span style={{ width: `${order.progress}%` }} /></div>
    <div className="mini-timeline" aria-label={t("订单流程", "Order workflow")}>
      {order.timeline.map((step) => <div className={`timeline-step ${step.state}`} key={step.key}>
        <CircleCheck size={14} /><span>{step.label}</span>
      </div>)}
    </div>
    <button type="button" className="text-action" onClick={() => onOpen?.(order.orderNo)}>{t("查看订单详情", "View order details")} <ChevronRight size={16} /></button>
  </article>;
}
